module.exports = __webpack_public_path__ + "img/1.db382403.jpg";